import React from "react";

interface Props {
  className?: string;
}

const GiftIcon = (props?: Props) => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props?.className}
    >
      <path
        d="M33 31C33 33.2 31.2 35 29 35H7C4.8 35 3 33.2 3 31V14C3 11.8 4.8 10 7 10H29C31.2 10 33 11.8 33 14V31Z"
        fill="#FDD888"
      />
      <path
        d="M36 11C36 13.2 34.2 15 32 15H4C1.8 15 0 13.2 0 11C0 8.8 1.8 7 4 7H32C34.2 7 36 8.8 36 11Z"
        fill="#FDD888"
      />
      <path d="M3 15H33V17H3V15Z" fill="#FCAB40" />
      <path
        d="M19 3H17C15.343 3 14 4.343 14 6V35H22V6C22 4.344 20.657 3 19 3Z"
        fill="#DA2F47"
      />
      <path
        d="M15.9991 6.99958C17.0991 6.99958 17.2621 6.48358 16.3601 5.85258L9.63813 1.14658C8.73613 0.515582 7.55313 0.780582 7.00713 1.73558L4.99113 5.26358C4.44513 6.21858 4.89913 6.99958 5.99913 6.99958H15.9991ZM19.9991 6.99958C18.8991 6.99958 18.7361 6.48358 19.6381 5.85258L26.3611 1.14658C27.2621 0.515582 28.4461 0.780582 28.9921 1.73558L31.0081 5.26258C31.5531 6.21858 31.0991 6.99958 29.9991 6.99958H19.9991Z"
        fill="#DA2F47"
      />
    </svg>
  );
};

export default GiftIcon;
